export class AnimaliaNarrativeBlock {
  constructor(
    public readonly title: string,
    public readonly body: string,
  ) {}
}
